import { WorkbenchViewport } from "../../workbench/state";

import { ContextWorkbenchEditorRegions } from "./contextWorkbenchEditorRegion";
import { ContextWorkbenchEditorSidebar } from "./contextWorkbenchEditorSidebar";
import { ContextWorkbenchEditorTabGroups } from "./contextWorkbenchEditorTab";
import {
  ContextWorkbenchEntities,
  getInitialContextWorkbenchEntities,
} from "./contextWorkbenchEntity";

export type ContextWorkbenchState = {
  view: "editor"; // TODO(CUR-980): add 'publish'
  entities: ContextWorkbenchEntities;
  editor: {
    tabGroups: ContextWorkbenchEditorTabGroups;
    viewport: WorkbenchViewport;
    regions: ContextWorkbenchEditorRegions;
    sidebar: ContextWorkbenchEditorSidebar;
  };
};

// implemented as a function to protect against changes
export const getContextWorkbenchInitialState = (): ContextWorkbenchState => {
  return {
    view: "editor",
    entities: getInitialContextWorkbenchEntities(),
    editor: {
      tabGroups: [],
      viewport: { type: "empty" },
      regions: {
        left: {
          position: "left",
          display: "sidebar",
          isOpen: true,
          size: 341,
          maxSize: 600,
          minSize: 200,
        },
        bottom: {
          position: "bottom",
          display: "none",
          isOpen: false,
          size: 0,
          minSize: 0,
          maxSize: 0,
        },
        right: {
          position: "right",
          display: "none",
          isOpen: false,
          size: 0,
          minSize: 0,
          maxSize: 0,
        },
      },
      sidebar: {
        panelId: "files",
        files: {
          type: "files",
        },
      },
    },
  };
};
